export default "__VITE_ASSET__ihkzPrTN__"